"use strict";

exports.__esModule = true;
exports.BalanceChangedStatus = void 0;
let BalanceChangedStatus;
exports.BalanceChangedStatus = BalanceChangedStatus;
(function (BalanceChangedStatus) {
  BalanceChangedStatus[BalanceChangedStatus["CHECKING"] = 0] = "CHECKING";
  BalanceChangedStatus[BalanceChangedStatus["SUCCESS"] = 1] = "SUCCESS";
  BalanceChangedStatus[BalanceChangedStatus["TIMEOUT"] = 2] = "TIMEOUT";
  BalanceChangedStatus[BalanceChangedStatus["UNKNOWN_ERROR"] = 3] = "UNKNOWN_ERROR";
})(BalanceChangedStatus || (exports.BalanceChangedStatus = BalanceChangedStatus = {}));